import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageCacheService {
  private cache = new Map<string, string>();

  /** [fallback] — заглушка вида позиции (NO_PHOTO), если фото нет или не загрузилось */
  async getImage(url: string, fallback: string = 'assets/no_photo_ru.png'): Promise<string> {
    if (!url || !url.trim()) {
      console.warn('[ImageCache] Пустой URL. Возвращаем fallback.');
      return fallback;
    }

    if (this.cache.has(url)) {
      // console.log(`[ImageCache] Используем кеш: ${url}`);
      return this.cache.get(url)!;
    }

    // console.log(`[ImageCache] Загружаем с сети: ${url}`);
    try {
      const response = await fetch(url, { cache: 'force-cache' }); // явно включаем кеш браузера
      if (!response.ok) {
        console.warn(`[ImageCache] Ошибка HTTP ${response.status} при загрузке ${url}`);
      }

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      this.cache.set(url, objectUrl);
      // console.log(`[ImageCache] Сохранили в кеш: ${url}`);
      return objectUrl;
    } catch (err) {
      // console.error('[ImageCache] Ошибка загрузки:', err);
      return fallback;
    }
  }
}